import React from 'react'
import AddItemBtn from 'Common/Custom/AddItemBtn';
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import PositionsListTable from "./components/PositionsListTable";

const  PositionsList = () => {
    return (
        <PageBody
            card={true}
            headerchildren={
                <>
                    <HeadingOne>Positions List</HeadingOne>
                    <AddItemBtn url="add-positions" title="Add Position" />
                </>
            }>
            <div className="col-12">
                <PositionsListTable />
            </div>
        </PageBody>
    );
};

export default PositionsList;




